import React, { useContext, useEffect, useState } from 'react';
import * as c from '../../ts/const';
import ImgPictures from '../components/img-pictures';
import HeaderSlider from '../components/header-slider';
import ParticlesBox from '../components/particles-box';
import SalePeriod from '../containers/sale-period';
import { SaleItemsContext } from '..';
//
// ヘッダ画像エリアの生成
const createPictureElement = (headerProps) => {
    if (!headerProps.image_name_md || !headerProps.image_name_sm) {
        return null;
    }
    return (React.createElement(ImgPictures, { fileNameLarge: `./assets/img/header/${headerProps.image_name_md}`, fileNameSmall: `./assets/img/header/${headerProps.image_name_sm}`, mediaQueryLarge: c.MEDIA_QUERY_LARGE, mediaQuerySmall: c.MEDIA_QUERY_SMALL, alt: headerProps.alt_text }));
};
//
// 商品リストからピックアップアイテムを抽出して返す
const getPickupItems = (saleItemListMap, saleOrder) => {
    // 開催中のセール商品リストを抽出
    const saleItemList = saleOrder.reduce((saleItemList, saleProp) => {
        if (saleProp && saleProp.sale_status === 1) {
            saleItemList = saleItemList.concat(saleItemListMap[saleProp.sale_period]);
        }
        return saleItemList;
    }, []);
    const pickupItemList = saleItemList.reduce((pickupItemList, saleItem) => {
        if (saleItem && saleItem.pickup) {
            pickupItemList.push(saleItem);
        }
        return pickupItemList;
    }, []);
    return pickupItemList;
};
const Header = () => {
    const [saleItemsState] = useContext(SaleItemsContext);
    const [pickupItemList, setPickupItemList] = useState([]);
    const [saleOrder, setSaleOrder] = useState([]);
    const [saleItems, setSaleItems] = useState({});
    const [headerProps, setHeaderProps] = useState({});
    //
    // 再レンダリング防止のためのクッション
    useEffect(() => {
        if (!saleItemsState) {
            return;
        }
        // スライド機能の初期化
        if (saleItemsState.saleOrder.length > 0 &&
            Object.keys(saleItemsState.saleItems).length > 0) {
            setSaleOrder(saleItemsState.saleOrder);
            setSaleItems(saleItemsState.saleItems);
        }
        // ヘッダ画像の初期化
        if (Object.keys(saleItemsState.headerProps).length > 0) {
            setHeaderProps(saleItemsState.headerProps);
        }
    }, [
        saleItemsState
    ]);
    //
    // スライダー用商品データを生成する
    useEffect(() => {
        // ピックアップ商品を抽出する
        setPickupItemList(getPickupItems(saleItems, saleOrder));
    }, [
        saleOrder,
        saleItems
    ]);
    return (React.createElement("div", { className: "header", id: "js-header" },
        React.createElement(ParticlesBox, { id: 'particles-box--header', settingsFile: './assets/json/particles-settings.json' },
            React.createElement("div", { className: 'header-body' },
                React.createElement("div", { className: "header-image" },
                    React.createElement("div", { className: "header-image-main" }, createPictureElement(headerProps))),
                React.createElement("div", { className: 'header-slider' },
                    React.createElement("div", { className: 'header-slider-main' },
                        React.createElement(HeaderSlider, { saleItemList: pickupItemList }))),
                React.createElement(SalePeriod, null)))));
};
export default Header;
